import { AutocompleteInput, useGetOne } from 'react-admin';
import { useState, useMemo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useInfiniteAutocomplete } from '../../../hooks/useInfiniteAutocomplete';

export const TestSeriesAutocomplete = (props: any) => {
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const { watch } = useFormContext();
    const currentValue = watch('testSeriesId');

    const { data: initialTestSeries } = useGetOne(
        'test-series',
        { id: currentValue },
        { enabled: !!currentValue && !selectedItem },
    );

    const {
        choices: fetchedChoices,
        isLoading,
        setSearchText,
        handleScroll,
    } = useInfiniteAutocomplete('test-series', {
        sort: { field: 'createdAt', order: 'DESC' },
        baseFilter: { deleted: false },
        searchField: 'title',
    });

    useEffect(() => {
        if (initialTestSeries && !selectedItem) {
            setSelectedItem(initialTestSeries);
        }
    }, [initialTestSeries, selectedItem]);

    const choices = useMemo(() => {
        const dataArray = fetchedChoices || [];
        if (selectedItem && !dataArray.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...dataArray];
        }
        return dataArray;
    }, [fetchedChoices, selectedItem]);

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'testSeriesId'}
            fullWidth
            label="Test Series"
            choices={choices}
            optionText="title"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
            ListboxProps={{ onScroll: handleScroll }}
        />
    );
};
